import React from "react";
import { motion } from "framer-motion";
import { Award, Film, Clock, Zap, Cpu, Globe } from "lucide-react";
import "./WhyChooseUs.css";

const WhyChooseUs = () => {
  const cards = [
    {
      icon: <Award className="icon" />,
      title: "Results-Driven",
      text: "We focus on measurable impact, not just visuals.",
    },
    {
      icon: <Film className="icon" />,
      title: "Cinematic Excellence",
      text: "Feature-film quality tailored for brands.",
    },
    {
      icon: <Clock className="icon" />,
      title: "Timely Delivery",
      text: "Precision workflows meet deadlines.",
    },
    {
      icon: <Zap className="icon" />,
      title: "Strategic Vision",
      text: "Data-backed creative decisions.",
    },
    {
        icon: <Cpu className="icon" />,
        title: "Innovative Technology",
        text: "Cutting-edge tools for immersive storytelling.",
      },
      {
        icon: <Globe className="icon" />,
        title: "Global Reach",
        text: "Locally crafted, globally impactful campaigns.",
      },
  ];

  // Animations (unchanged)
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const cardItem = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <section className="why-choose-us">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Why Partner With Us?
      </motion.h2>
      <motion.div
        className="cards-container"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
      >
        {cards.map((card, index) => (
          <motion.div
            key={index}
            className="card"
            variants={cardItem}
            whileHover={{
              y: -3,
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div className="icon-wrapper">{card.icon}</div>
            <h3>{card.title}</h3>
            <p>{card.text}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default WhyChooseUs;